import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_gifts: FaireCategoryEntity = {
  token: "cat_gifts",
  type: "category",
  name: "Gifts",
  level: 1,
  href: "/category/gifts",
  childCategoryTokens: [
    "cat_gifts-all",
    "cat_gifts-new-products",
    "cat_gifts-new-brands",
    "cat_gifts-bestsellers",
    "cat_gifts-occasion",
    "cat_gifts-price",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
